import styled from 'styled-components'

import Typography from '~components/Typography'

const ContactLink = styled(Typography)`
  display: block;
`

export default ContactLink
